import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { addJob, getJobs } from './jobAPI';
import axios from "../../utils/axios"

const initialState = {
    jobs: [],
    loading: false,
    selectedJobType: null,
    allJobs: [],
    sort: "",
    search: "",

};


export const fetchJobsAsync = createAsyncThunk(
    'jobs/fetchJobs',
    async ({ sort, search }) => {
        const jobs = await getJobs(sort, search);
        //  console.log("jobs from slice  ", jobs);
        return jobs;
    }
);
export const createJobAsync = createAsyncThunk(
    'jobs/createJob',
    async (jobData) => {
        const job = await addJob(jobData);
        console.log("job added from slice  ", job);
        return job;
    }
);
export const deleteJobAsync = createAsyncThunk(
    'jobs/deleteJob',
    async (jobId) => {
        const response = await axios.delete(`/jobs/${jobId}`);
        return response.data;
    }
);
export const editJobAsync = createAsyncThunk(
    "jobs/editJob",
    async ({ id, newData }) => {
        const response = await axios.patch(`/jobs/${id}`, newData);
        return response.data;
    }
);

const jobSlice = createSlice({
    name: 'jobs',
    initialState,
    reducers: {
        setSelectedJobType: (state, action) => {
            state.selectedJobType = action.payload;
        },
        sortBy: (state, action) => {
            state.sort = action.payload;
        },
        searchBy: (state, action) => {
            state.search = action.payload.toLowerCase();
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchJobsAsync.pending, (state) => {
                state.loading = true;
            })
            .addCase(fetchJobsAsync.fulfilled, (state, action) => {
                state.loading = false;
                state.jobs = action.payload;
                state.allJobs = action.payload;
            })
            .addCase(createJobAsync.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(createJobAsync.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.jobs.push(action.payload);
            })
            .addCase(createJobAsync.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.error.message;
            })
            .addCase(deleteJobAsync.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(deleteJobAsync.fulfilled, (state, action) => {
                state.status = 'succeeded';
                console.log(action.payload);
                state.jobs = state.jobs.filter(job => job.id !== action.meta.arg);
            })
            .addCase(deleteJobAsync.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.error.message;
            })
            .addCase(editJobAsync.pending, (state) => {
                state.status = "loading";
            })
            .addCase(editJobAsync.fulfilled, (state, action) => {
                state.status = "succeeded";
                const updatedJob = action.payload;
                const existingJob = state.jobs.find((job) => job.id === updatedJob.id);
                if (existingJob) {
                    // If the updated job already exists in the store, replace it with the updated data
                    console.log("updatinngg......");
                    Object.assign(existingJob, updatedJob);
                } else {
                    // If the updated job doesn't exist in the store, add it to the end of the array
                    state.jobs.push(updatedJob);
                }
            })
            .addCase(editJobAsync.rejected, (state, action) => {
                state.status = "failed";
                state.error = action.error.message;
            });
    },
});
export const { setSelectedJobType, searchBy, sortBy } = jobSlice.actions;

export const selectJobs = (state) => {
    const selectedJobType = state.jobs.selectedJobType;
    const jobs = state.jobs.jobs;
    const allJobs = state.jobs.allJobs;
    console.log("select jobs getting called", selectedJobType);
    // console.log(jobs.filter((job) => job.type === selectedJobType));
    const filteredJobs = selectedJobType ? jobs.filter((job) => job.type === selectedJobType) : allJobs;
    return {
        ...jobs,
        jobs: filteredJobs,
    };
};

export default jobSlice.reducer;
